import * as React from 'react';

export default (
  <svg height="18" width="18" viewBox="0 0 18 18">
    <path d="M9 12.5a.702.702 0 01-.7-.7V9c0-.385.315-.7.7-.7.385 0 .7.315.7.7v2.8c0 .385-.315.7-.7.7zm0-5.6a.7.7 0 110-1.4.7.7 0 010 1.4zM9 2C5.136 2 2 5.136 2 9s3.136 7 7 7 7-3.136 7-7-3.136-7-7-7zm0 12.6A5.607 5.607 0 013.4 9c0-3.087 2.513-5.6 5.6-5.6 3.087 0 5.6 2.513 5.6 5.6 0 3.087-2.513 5.6-5.6 5.6z" />
  </svg>
);
